/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthAuditRouteImport } from './routes/_auth/audit'
import { Route as AuthBreakGlassRouteImport } from './routes/_auth/break-glass'
import { Route as AuthDeletionsRouteImport } from './routes/_auth/deletions'
import { Route as AuthJobsRouteImport } from './routes/_auth/jobs'
import { Route as AuthPlansRouteImport } from './routes/_auth/plans'
import { Route as AuthSecurityRouteImport } from './routes/_auth/security'
import { Route as AuthOrganizationsIndexRouteImport } from './routes/_auth/organizations.index'
import { Route as AuthOrganizationsOrgIdRouteImport } from './routes/_auth/organizations.$orgId'
import { Route as AuthUsersUserIdRouteImport } from './routes/_auth/users.$userId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditRoute = AuthAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBreakGlassRoute = AuthBreakGlassRouteImport.update({
  id: '/break-glass',
  path: '/break-glass',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDeletionsRoute = AuthDeletionsRouteImport.update({
  id: '/deletions',
  path: '/deletions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJobsRoute = AuthJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPlansRoute = AuthPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSecurityRoute = AuthSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrganizationsIndexRoute = AuthOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrganizationsOrgIdRoute = AuthOrganizationsOrgIdRouteImport.update({
  id: '/organizations/$orgId',
  path: '/organizations/$orgId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersUserIdRoute = AuthUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/signed-out': typeof SignedOutRoute
  '/audit': typeof AuthAuditRoute
  '/break-glass': typeof AuthBreakGlassRoute
  '/deletions': typeof AuthDeletionsRoute
  '/jobs': typeof AuthJobsRoute
  '/plans': typeof AuthPlansRoute
  '/security': typeof AuthSecurityRoute
  '/organizations/$orgId': typeof AuthOrganizationsOrgIdRoute
  '/users/$userId': typeof AuthUsersUserIdRoute
  '/organizations/': typeof AuthOrganizationsIndexRoute
}
export interface FileRoutesByTo {
  '/signed-out': typeof SignedOutRoute
  '/audit': typeof AuthAuditRoute
  '/break-glass': typeof AuthBreakGlassRoute
  '/deletions': typeof AuthDeletionsRoute
  '/jobs': typeof AuthJobsRoute
  '/plans': typeof AuthPlansRoute
  '/security': typeof AuthSecurityRoute
  '/': typeof AuthIndexRoute
  '/organizations/$orgId': typeof AuthOrganizationsOrgIdRoute
  '/users/$userId': typeof AuthUsersUserIdRoute
  '/organizations': typeof AuthOrganizationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/_auth/audit': typeof AuthAuditRoute
  '/_auth/break-glass': typeof AuthBreakGlassRoute
  '/_auth/deletions': typeof AuthDeletionsRoute
  '/_auth/jobs': typeof AuthJobsRoute
  '/_auth/plans': typeof AuthPlansRoute
  '/_auth/security': typeof AuthSecurityRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/organizations/$orgId': typeof AuthOrganizationsOrgIdRoute
  '/_auth/users/$userId': typeof AuthUsersUserIdRoute
  '/_auth/organizations/': typeof AuthOrganizationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signed-out'
    | '/audit'
    | '/break-glass'
    | '/deletions'
    | '/jobs'
    | '/plans'
    | '/security'
    | '/organizations/$orgId'
    | '/users/$userId'
    | '/organizations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signed-out'
    | '/audit'
    | '/break-glass'
    | '/deletions'
    | '/jobs'
    | '/plans'
    | '/security'
    | '/'
    | '/organizations/$orgId'
    | '/users/$userId'
    | '/organizations'
  id:
    | '__root__'
    | '/_auth'
    | '/signed-out'
    | '/_auth/audit'
    | '/_auth/break-glass'
    | '/_auth/deletions'
    | '/_auth/jobs'
    | '/_auth/plans'
    | '/_auth/security'
    | '/_auth/'
    | '/_auth/organizations/$orgId'
    | '/_auth/users/$userId'
    | '/_auth/organizations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  SignedOutRoute: typeof SignedOutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit': {
      id: '/_auth/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthAuditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/break-glass': {
      id: '/_auth/break-glass'
      path: '/break-glass'
      fullPath: '/break-glass'
      preLoaderRoute: typeof AuthBreakGlassRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/deletions': {
      id: '/_auth/deletions'
      path: '/deletions'
      fullPath: '/deletions'
      preLoaderRoute: typeof AuthDeletionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/jobs': {
      id: '/_auth/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthJobsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/plans': {
      id: '/_auth/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AuthPlansRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/security': {
      id: '/_auth/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AuthSecurityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organizations/': {
      id: '/_auth/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthOrganizationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organizations/$orgId': {
      id: '/_auth/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/organizations/$orgId'
      preLoaderRoute: typeof AuthOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/$userId': {
      id: '/_auth/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthUsersUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAuditRoute: typeof AuthAuditRoute
  AuthBreakGlassRoute: typeof AuthBreakGlassRoute
  AuthDeletionsRoute: typeof AuthDeletionsRoute
  AuthJobsRoute: typeof AuthJobsRoute
  AuthPlansRoute: typeof AuthPlansRoute
  AuthSecurityRoute: typeof AuthSecurityRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthOrganizationsOrgIdRoute: typeof AuthOrganizationsOrgIdRoute
  AuthUsersUserIdRoute: typeof AuthUsersUserIdRoute
  AuthOrganizationsIndexRoute: typeof AuthOrganizationsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuditRoute: AuthAuditRoute,
  AuthBreakGlassRoute: AuthBreakGlassRoute,
  AuthDeletionsRoute: AuthDeletionsRoute,
  AuthJobsRoute: AuthJobsRoute,
  AuthPlansRoute: AuthPlansRoute,
  AuthSecurityRoute: AuthSecurityRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthOrganizationsOrgIdRoute: AuthOrganizationsOrgIdRoute,
  AuthUsersUserIdRoute: AuthUsersUserIdRoute,
  AuthOrganizationsIndexRoute: AuthOrganizationsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  SignedOutRoute: SignedOutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
